export default function skipSessionResultFeedback() {
  return {
    type: "skipSessionResultFeedback" as const,
  };
}
